import type { ConfigProviderProps } from 'antd'
import { App, ConfigProvider } from 'antd'
import { useTranslation } from 'react-i18next'
import { useThemeStore } from './stores/theme'

export function Provider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation()
  const { mode, setMode } = useThemeStore()
  const lightTheme: ConfigProviderProps['theme'] = {
    cssVar: true,
    hashed: false,
    token: {
      colorPrimary: '#006FEE',
      colorSuccess: '#17c964',
      colorWarning: '#f5a524',
      // colorInfo: '#7828c8',
      borderRadius: 8,
      borderRadiusLG: 12,
      colorTextBase: '#18181b',
      colorBgBase: '#fff',
    },
  }
  const darkTheme: ConfigProviderProps['theme'] = {
    token: {
      colorPrimary: '#006FEE',
      // colorInfo: '#9353d3',
      colorSuccess: '#17c964',
      colorWarning: '#f5a524',
      borderRadius: 8,
      colorTextBase: '#fafafa',
      colorBgBase: '#000',
      colorIcon: '#18181b',
    },
  }
  useEffect(() => {
    Telegram.WebApp.onEvent('themeChanged', () => {
      setMode(Telegram?.WebApp.colorScheme)
    })
    const language = localStorage.getItem('LANGUAGE')
    if (language)
      i18n.changeLanguage(language)
    else
      i18n.changeLanguage('zh')
  }, [i18n, setMode])
  return (
    <ConfigProvider variant="filled" theme={mode === 'light' ? lightTheme : darkTheme}>
      <App component={false} message={{ top: 81 }}>
        {children}
      </App>
    </ConfigProvider>
  )
}
